import { mapActions } from 'vuex';
import axios from 'axios';
import dayjs from "dayjs";
import UsersGrid from './components/UsersGrid/UsersGrid.vue';
import AddUserModal from './components/AddUserModal/AddUserModal.vue';
import SyncDatabasesModal from './components/SyncDatabasesModal/SyncDatabasesModal.vue';

export default {
	components: { UsersGrid, AddUserModal, SyncDatabasesModal },
	data() {
		return {
			showAddUser: false,
			search: '',
			exportDisabled: false,
			syncDbStarted: false,
			visible: false,
			visibleExportIndicators: false,
			visibleImportMetrs: false,
			syncMonth: dayjs().subtract(1, 'month'),
			indicatorsMonth: null,
			importMetersFile: null,
			isImportingMeters: false,
			indicatorExportType: "PDF"
		}
	},
	methods: {
		...mapActions(['getAllUsers', 'makeDbDump', 'synchroniseDatabases']),
		hendleSearchClick() {
			this.getAllUsers({
				contractNumber: this.search
			})
		},
		exportToCSV() {
			this.exportDisabled = true;
			axios.get('api/user/export', {
			}).then(response => {
				const downloadLink = document.createElement("a");
				const blob = new Blob(["\ufeff", response.data]);
				const url = URL.createObjectURL(blob);
				downloadLink.href = url;
				downloadLink.download = "Users.csv";
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
				this.exportDisabled = false;
			}, error => {
				console.log(error);
				this.exportDisabled = false;
			})

		},
		syncDatabases() {
			this.visible = false;
			this.syncDbStarted = true;
			this.makeDbDump().then(() => {
				this.synchroniseDatabases({
					data: dayjs(this.syncMonth).endOf('month').format("YYYY-MM-DD")
				}).catch(() => {
					this.syncDbStarted = false;
					this.$notify.error({
						title: 'Помилка',
						message: 'Сталася помилка під час синхронізації БД.',
					});

				});
			}).catch(() => {
				this.syncDbStarted = false;
				this.$notify.error({
					title: 'Помилка',
					message: 'Сталася помилка під час створення резервної копії БД.',
				});
			});
		},
		exportIndicators() {
			this.visibleExportIndicators = false;
		
			let params = {
				type: this.indicatorExportType.toLowerCase()
			};
			if (this.indicatorsMonth) {
				params.period = dayjs(this.indicatorsMonth).endOf('month').format("YYYY-MM-DD");
			}
		
			axios({
				url: 'api/indicator/report',
				method: 'GET',
				responseType: 'blob',
				params
			}).then(response => {
				const downloadLink = document.createElement('a');
				const blob = new Blob([response.data]);
				const url = URL.createObjectURL(blob);
				downloadLink.href = url;
		
				// автоматично ставимо ім’я файлу за типом
				const fileExtension = this.indicatorExportType.toLowerCase() === 'xlsx' ? 'xlsx' : 'pdf';
				downloadLink.download = `Report.${fileExtension}`;
		
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
				this.exportDisabled = false;
			}).catch(error => {
				console.log(error);
				this.exportDisabled = false;
			});
		},
		onImportMetersChange(file) {
			this.importMetersFile = file;
		},
		async importMeters() {			
			this.isImportingMeters = true
			const formData = new FormData();
			formData.append('excelFile', this.importMetersFile.raw);
			try {
				const response = await axios.post('/api/meter/import-meters', formData);
				if (response) {
					this.$notify.success({
						title: 'Успіх!',
						message: 'Лічильники успішно імпортовано.',
					});
					this.importMetersFile = null;
					this.visibleImportMetrs = false
				}	
				this.isImportingMeters = false			
			} catch (error) {
				this.$notify.error({
					title: 'Помилка',
					message: 'Сталася помилка під час імпорту лічильників.',
				});
				this.isImportingMeters = false			
			}
		}
	},

}